module.exports = __webpack_public_path__ + "img/risk_pop_content.3f537357.png";